import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudSelectModule,
	FreudTagModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryOutcomeComponent } from './promptuary-outcome.component';

@NgModule({
	declarations: [PromptuaryOutcomeComponent],
	imports: [
		CommonModule,
		FreudSelectModule,
		TranslateModule.forChild(),
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		FreudTagModule,
		FreudTooltipModule,
	],
	exports: [PromptuaryOutcomeComponent],
	providers: [],
})
export class PromptuaryOutcomeModule {}
